export default "__VITE_ASSET__BhvJQTOL__"